import { render, staticRenderFns } from "./NewsCategoryNav.vue?vue&type=template&id=6c9c03ae&"
import script from "./NewsCategoryNav.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports